(() => {
  'use strict';
  if (window.__fpCollectionHeartBridgeV1) return;
  window.__fpCollectionHeartBridgeV1 = true;

  const selector = '.card-wrapper.product-card-wrapper [data-fp-collection-heart]';
  const productPattern = /^gid:\/\/shopify\/Product\/[1-9]\d*$/;
  const variantPattern = /^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/;
  const nativeSelector = [
    '[data-fp-wishlist-toggle]:not([data-fp-collection-heart])',
    '[data-fp-wishlist-heart]:not([data-fp-collection-heart])',
    '[data-flauschwishlist-heart]',
    'button.fp-wishlist-heart',
    'button.flauschwishlist-heart',
    'button.flauschwishlist-button',
    'button[data-fp-wishlist-action]'
  ].join(',');

  let subscribedApi = null;
  let unsubscribe = null;
  let queued = false;
  let announcing = null;

  function api() {
    const service = window.FlauschWishlist;
    if (!service || typeof service.add !== 'function' ||
        typeof service.remove !== 'function' ||
        typeof service.getState !== 'function') return null;
    return service;
  }

  function announce(value) {
    if (!announcing) {
      announcing = document.createElement('span');
      announcing.className = 'visually-hidden';
      announcing.setAttribute('role', 'status');
      announcing.setAttribute('aria-live', 'polite');
      announcing.setAttribute('data-fp-heart-announcement', '');
      document.body.appendChild(announcing);
    }
    announcing.textContent = value;
  }

  function productId(button) {
    const gid = button.dataset.fpProductGid || '';
    return productPattern.test(gid) ? gid : null;
  }

  function selectedVariant(button) {
    const card = button.closest('.card-wrapper.product-card-wrapper');
    if (!card) return null;
    const chosenColor = card.querySelector('.color-swatches .color-swatch.active');
    if (chosenColor) {
      const available = chosenColor.getAttribute('data-fp-wishlist-available-variant-id') || '';
      return /^[1-9]\d*$/.test(available) ? 'gid://shopify/ProductVariant/' + available : null;
    }
    const activeSelection = card.querySelector(
      '[data-product-variant-id].active, [data-variant-id].active, [aria-selected="true"][data-variant-id]'
    );
    const numeric = activeSelection?.getAttribute('data-product-variant-id') ||
      activeSelection?.getAttribute('data-variant-id') || '';
    const found = /^\d+$/.test(numeric) ? 'gid://shopify/ProductVariant/' + numeric : numeric;
    if (variantPattern.test(found)) return found;
    const fallback = button.dataset.fpVariantGid || '';
    return variantPattern.test(fallback) ? fallback : null;
  }

  function hasNativeHeart(button) {
    const card = button.closest('.card-wrapper.product-card-wrapper');
    return !!card && !!card.querySelector(nativeSelector);
  }

  function activeProductSet(service) {
    try {
      const state = service.getState();
      if (!state || !Array.isArray(state.items)) return null;
      return new Set(state.items.filter(item => item &&
        typeof item.productGid === 'string').map(item => item.productGid));
    } catch {
      return null;
    }
  }

  function refresh() {
    queued = false;
    const service = api();
    if (service && service !== subscribedApi) {
      if (typeof unsubscribe === 'function') unsubscribe();
      unsubscribe = null;
      subscribedApi = service;
      if (typeof service.subscribe === 'function') {
        try {
          const cleanup = service.subscribe(schedule);
          if (typeof cleanup === 'function') unsubscribe = cleanup;
        } catch {}
      }
    }
    const items = service ? activeProductSet(service) : null;
    for (const button of document.querySelectorAll(selector)) {
      const gid = productId(button);
      if (!gid) {
        button.hidden = true;
        continue;
      }
      if (hasNativeHeart(button)) {
        button.hidden = true;
        continue;
      }
      button.hidden = false;
      if (button.dataset.fpBusy === 'true') continue;
      let pressed = items?.has(gid);
      if (pressed === undefined && service && typeof service.isActive === 'function') {
        try { pressed = service.isActive(gid) === true; } catch {}
      }
      if (pressed !== undefined) button.setAttribute('aria-pressed', String(pressed));
      const selected = button.getAttribute('aria-pressed') === 'true';
      const text = selected ? button.dataset.fpHeartRemove : button.dataset.fpHeartAdd;
      if (text) {
        button.setAttribute('aria-label', text);
        button.title = text;
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(refresh);
  }

  function canChange(service) {
    try {
      return typeof service?.canMutate !== 'function' || service.canMutate() === true;
    } catch {
      return false;
    }
  }

  async function toggle(button) {
    const gid = productId(button);
    const service = api();
    if (!gid || button.dataset.fpBusy === 'true') return;
    if (!service || !canChange(service)) {
      announce(button.dataset.fpHeartWait || 'Die Schatzkammer braucht einen Augenblick.');
      return;
    }
    const active = button.getAttribute('aria-pressed') === 'true';
    const variantGid = selectedVariant(button);
    button.dataset.fpBusy = 'true';
    button.disabled = true;
    try {
      if (active) {
        await service.remove({ productGid: gid, surface: 'COLLECTION_CARD' });
      } else {
        await service.add({
          productGid: gid,
          observedVariantGid: variantGid,
          surface: 'COLLECTION_CARD'
        });
      }
      schedule();
    } catch {
      announce(button.dataset.fpHeartUnavailable || 'Deine Schatzkammer ist gerade nicht erreichbar.');
    } finally {
      button.disabled = false;
      delete button.dataset.fpBusy;
      schedule();
    }
  }

  document.addEventListener('click', event => {
    const button = event.target?.closest?.(selector);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    void toggle(button);
  }, true);
  document.addEventListener('fp:wishlist:state', schedule);
  window.addEventListener('fp:wishlist:state', schedule);
  window.addEventListener('fp:wishlist:client', schedule);
  document.addEventListener('shopify:section:load', schedule);

  function start() {
    schedule();
    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver(schedule);
      observer.observe(document.body, {childList: true, subtree: true});
    }
    let tries = 0;
    const timer = setInterval(() => {
      if (api() || ++tries >= 60) {
        clearInterval(timer);
      }
      schedule();
    }, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
